module.exports = __webpack_public_path__ + "static/media/empty_map.134167e4.svg";